/**
* 云之家
*/
import '@common/polyfill/src/promise'
import cookie from 'js-cookie'
import urlTool from '@common/url'
import ajax from '@finance/ajax'
import domain from '@common/domain'
import useragent from '@common/useragent'

import { callbackHandler } from '../utils'

import BaseAuth from './base'

class YunzhijiaAuth extends BaseAuth {
  constructor(options) {
    super(options)
    if (useragent.isYunzhijia) {
      this.isClientHit = true
    }
  }
  // 请求登陆接口
  requestYunzhijiaApi(queryStr) {
    ajax.request({
      url: `${domain.api}/userws/ws/yzj/v1/login`,
      body: { ticket: cookie.get('yzj_ticket') }, // 目前cookie字段yzj_ticket是在product项目index页面设置的，由云之家渠道带来的
    }).then((result) => {
      if (result.succeed) {
        if (result.data.isLoginSuccess) {
          window.location.href = this.options.forwardUrl
        } else {
          cookie.set('success_forwardUrl', this.options.forwardUrl, { domain: urlTool('domain') })
          window.location.href = `${domain.res}/public-vue/thirdparty/index.html#/kdweibo/phone?openId=${result.data.openId}${queryStr ? ('&' + queryStr) : ''}`
        }
      } else {
        callbackHandler(this.options.error, { msg: result.msg })
      }
    }).catch((error) => {
      console.error('RequestYzjApi Error:', error)
      callbackHandler(this.options.error, { msg: '登录失败' })
    })
  }
  // 获取token
  getToken() {
    if (!this.isClientHit) return undefined
    return Promise.resolve({})
  }
  // 登录
  login() {
    if (!this.isClientHit) return
    if (this.loginType.silent || this.checkIsLogin()) {
      // 如果是静默登录，则不跳转到登录页面或授权页面
      this.requestLoginApiSuccessCallback()
    } else {
      let queryStr = ''
      if (this.accountType.acc) {
        queryStr = 'accountType=acc'
      } else if (this.accountType.custody) {
        queryStr = 'accountType=custody'
      }
      this.requestYunzhijiaApi(queryStr)
    }
  }
}

export default YunzhijiaAuth



// WEBPACK FOOTER //
// ./node_modules/@finance/login/src/client/yunzhijia.js